// extracted by mini-css-extract-plugin
export default {"emailWrapper":"Admin_emailWrapper__URKRc","emailEnd":"Admin_emailEnd__G9ykK"};